// removed by extract-text-webpack-plugin
module.exports = {"MainContainer":"formslist__MainContainer__3Ec5C","ListSection":"formslist__ListSection__3RVC4"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/FormsList/formslist.css
// module id = 156
// module chunks = 0